export const MAX_IMAGE_WIDTH = 178;
export const MAX_IMAGE_HEIGHT = 133;
export const PLACEHOLDER = 'PLACEHOLDER';
